// Illustrative search results for the Auction search page mock.
export const rows = [
    {
        car: '1997 Mitsubishi Delica Space Gear Exceed',
        src: 'JCD',
        meta: 'Lot 22914 · PE8W · 118,000 km · AT · 4WD · Thu 12 Mar',
        g: '3.5',
        isNew: true,
        list: false
    },
    {
        car: '1999 Mitsubishi Delica Space Gear Chamonix',
        src: 'JDM Auc',
        meta: 'Lot 60231 · PE8W · 96,000 km · AT · 4WD · Thu 12 Mar',
        g: '4',
        isNew: true,
        list: false
    },
    {
        car: '1998 Mitsubishi Delica Space Gear Super Exceed',
        src: 'PCJ',
        meta: 'Lot 18077 · PE8W · 134,000 km · AT · 4WD · Fri 13 Mar',
        g: '3.5',
        isNew: false,
        list: true
    },
    {
        car: '1996 Mitsubishi Delica Space Gear XR',
        src: 'JCD',
        meta: 'Lot 30415 · PE8W · 142,000 km · AT · 4WD · Sat 14 Mar',
        g: '3.5',
        isNew: false,
        list: false
    },
    {
        car: '2001 Mitsubishi Delica Space Gear Chamonix',
        src: 'JDM Auc',
        meta: 'Lot 71102 · PE8W · 121,000 km · AT · 4WD · Sat 14 Mar',
        g: '4',
        isNew: false,
        list: false
    }
];
